module.exports = __webpack_public_path__ + "static/media/ic-cross.9b60ab67.svg";